import axios from 'axios';

const apiVideoStorage = axios.create({
  baseURL: process.env.REACT_APP_ORACLE_URL_UPLOAD_VIDEO,
});

export default apiVideoStorage;
